module.exports = __webpack_public_path__ + "img/logo.7f752f88.png";